import React from 'react';
import { Backdrop, Box } from '@mui/material';

const LoadingComponent = () => (
  <Backdrop
    open
    sx={{
      color: '#fff',
      backgroundColor: 'var(--ds-brand-navy)',
      zIndex: theme => theme.zIndex.drawer + 1,
    }}
  >
    <Box
      component="img"
      src="/assets/imgs/remus_icon_256x256.png"
      sx={{
        width: 128,
        height: 128,
        animation: 'remusPulse 1s infinite alternate',
        '@keyframes remusPulse': {
          '0%': { transform: 'scale(1)' },
          '100%': { transform: 'scale(1.1)' },
        },
      }}
    />
  </Backdrop>
);

export default LoadingComponent;
